import React, { useState } from 'react'
import NavbarComponent from '../components/navbar-component/navbar-component'
import styled from 'styled-components';
import { Breadcrumb } from 'rsuite';
import { Link, useNavigate } from 'react-router-dom';
import FooterComponent from '../components/common/footer-component/footer-component';
import { Box, Button, Card, CardActionArea, CardContent, Grid, Typography } from '@mui/material';
import { Download as DownloadIcon } from '@mui/icons-material';
import { BaseUrl } from '../api/axios';
import { Configurations } from '../config';
import DownloadIcon2 from '../assets/download-icon.png';
import ListIcon from '../assets/list-icon.png';

export default function DownloadPage() {

    const Container = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
  color: #333;
`;

const Title = styled.h1`
  text-align: center;
  font-size: 1.8em;
  margin-bottom: 20px;
  font-family: Arial, sans-serif;
`;
const navigate = useNavigate();


// const downloadLinks = [
    // {
    //   title: "11Nomination Form – University Provident Fund",
    //   subList: [
    //     {
    //       title: "Nomination Form – University Provident Fund",
    //       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    //       type: 'list',//link   list
    //       subList:[
    //         {
    //           title: "Nomination Form – University Provident Fund",
    //           url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    //         },
    //         {
    //           title: "Nomination Form – University Provident Fund",
    //           url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    //         }
    //       ]
    //     },
    //     {
    //       title: "Nomination Form – University Provident Fund",
    //       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    //       type: 'link'//link   list
    //     }
    //   ],
    //   url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    //   type: 'list'//list   download
    // },
//     {
//       title: "Nomination Form – University Provident Fund",
//       //description: "A clean and modern resume template for professionals.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
//       type: 'download'//list   download
//     },
//     {
//       title: "Information for Recruitment of Contract and Temporary Employees",
//       //description: "A comprehensive proposal template for project planning.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Information-for-Recruitment-of-Contract-and-Temporary-Employees.pdf",
//       type: 'list'//list   download
//     },
//     {
//       title: "Check List - Application for the Post of Professor",
//       //description: "An example business report format for corporate use.",
//       url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Document-Check-List-for-the-Professor-Application.docx",
//       type: 'list'//list   download
//     }
//   ];



const downloadLinks = [

  {
    title: "Procurement Manual 2025 - Formats",
    subList: [
      {
        title: "Appiontments & Absence",
        subList: [
          {
            title: "Annexure IV - Chapter 02 - Notification of Absence of a Committee Member",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Appiontments & Absence/Annexure IV - Chapter 02 -Notification of Absence of a Committee Member.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure V - Chapter 02 - Format for Requesting the Appointment of HLPCSHLPC, and BEC",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Appiontments & Absence/Annexure V - Chapter 02 -Format for Requesting the Appointment of HLPCSHLPC, and BEC.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VI - Chapter 02 - Format for Requesting ApprovalConcurrence for Appointing SHLPC",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Appiontments & Absence/Annexure VI - Chapter 02 -Format for Requesting ApprovalConcurrence for Appointing SHLPC.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VII - Chapter 02 - Format to Request the Appointment of MPCDPCPPCRPC and BEC",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Appiontments & Absence/Annexure VII - Chapter 02 -Format to Request the Appointment of MPCDPCPPCRPC and BEC.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Bid Evaluation Committee Minutes",
        subList: [
          {
            title: "Annexure II - Chapter 02 - Bid Evaluation Committee Meeting Minutes",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid Evaluation Committee Minutes/Annexure II - Chapter 02 -Bid Evaluation Committee Meeting Minutes.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure III - Chapter 02 -Bid Evaluation Summary Report",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid Evaluation Committee Minutes/Annexure III - Chapter 02 -Bid Evaluation Summary Report.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Bid Opening Documents",
        subList: [
          {
            title: "Annexure I- Chapter 06 - BidsProposals Opening Minutes – Attendance",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid Opening Documents/Annexure I- Chapter 06-BidsProposals Opening Minutes –Attendance..doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II - Chapter 06 - BidProposal Opening Minutes – General Information",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid Opening Documents/Annexure II- Chapter 06-BidProposal Opening Minutes – General Information..doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure III - Chapter 06 -Bid Proposal Opening Minutes - Financial Information",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid Opening Documents/Annexure III- Chapter 06-Bid Proposal Opening Minutes - Financial Information.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Bid - Proposal Evaluation",
        subList: [
          {
            title: "Stage 01 - Basic Dta &  Records of Bid Proposal Opening",
            type: 'list',//link   list
            subList:[
              {
                title: "Annexure 1 - Use of Bid Evaluation Report - Basic Data",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure 1 -Use of Bid Evaluation Report  - Basic Data.doc",
              },
              {
                title: "Annexure 11 - Records of Bid Proposal Opening",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure 11 - Records of Bid Proposal Opening.doc",
              }
            ]
          },
          {
            title: "Stage 02 - Completeness & Substantial Responsiveness of Bids",
            type: 'list',//link   list
            subList:[
              {
                title: "Annexure 111 - Examination of Completeness of BidProposal Documents Stage 01",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure 111 - Examination of Completeness of BidProposal Documents Stage 01.doc",
              },
              {
                title: "Annexure IV (A) - Chapter 07 - Substantial Responsiveness of Bids - Goods",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure IV(a)-Chapter 07  - Substantial Responsiveness of Bids  - Goods.doc",
              },
              {
                title: "Annexure IV (B) - Chapter 07  - Substantial Responsiveness of Bids - Works",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure IV(b) -Chapter 07  - Substantial Responsiveness of Bids -Works.doc",
              },
              {
                title: "Annexure V - Chapter 07  Substantial Responsiveness of Bids - Technical Requirements",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure V - Chapter 07  Substantial Responsiveness of Bids- Technical Requirements.doc",
              }
            ]
          },
          {
            title: "Stage 03 - Bids or Proposals Comparison",
            type: 'list',//link   list
            subList:[
              {
                title: "Annexure VI (B) - Chapter 07 - Table of Bids or Proposals Comparison - GoodsServices",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure VI (B) - Chapter 07-Table of Bids or Proposals Comparison - GoodsServices.doc",
              },
              {
                title: "Annexure VI (A) - Chapter 07 - Table of Bids - Proposals Comparison - Work Contracts",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure VI(a) - Chapter 07  -  Table of Bids - Proposals Comparison - Work Contracts.doc",
              },
              {
                title: "Annexure VII (B) - Chapter 07 - Supplies - Table of Bids Comparison - Prices After Domestic Preference",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure VII(b) - Chapter 07  - Supplies-Table of Bids Comparison - Prices After Domestic Preference.doc",
              },
              {
                title: "AnnexureVII (A) Chapter 07 - Contracts Table of Bids Comparison - Prices After Domestic Preference",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/AnnexureVII( a) Chapter 07 - Contracts Table of Bids Comparison -Prices After Domestic Preference.doc",
              }
            ]
          },
          {
            title: "Stage 04 - Format of Bid Evaluation Report",
            type: 'list',//link   list
            subList:[
              {
                title: "Annexure VIII - Chapter 07 - Format of Bid Evaluation Report",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Annexure VIII  - Chapter 07 - Format of Bid Evaluation Report.doc",
              }
            ]
          },
          {
            title: "Summary - Bid Proposal Evaluation - Chapter 07",
            type: 'list',//link   list
            subList:[
              {
                title: "Summary - Bid - Proposal Evaluation (Chapter 07)",
                url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bid - Proposal Evaluation/Summary -Bid- Proposal Evaluation (Chapter 07).doc",
              }
            ]
          }
        ],
        type: 'list2'//list   download
      },
      {
        title: "Bidding Documents",
        subList: [
          {
            title: "Bidding Document -National Shopping",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Bidding Documents/Bidding Document -National Shopping.docx",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Declarations",
        subList: [
          {
            title: "Annexure I - Chapter 01 - Declarations by Members of Bid Evaluation Committees",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Declarations/Annexure I  -Chapter 01 -Declarations by Members of Bid Evaluation Committees.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure I - Chapter 01 - Declarations by Members of Procurement Committees",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Declarations/Annexure I -Chapter 01 -Declarations by Members of Procurement Committees.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II - Chapter 01 - Declarations by Other Officers Assisting Procurement",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Declarations/Annexure II -Chapter 01 -Declarations by Other Officers Assisting Procurement.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II - Chapter 01 - Declarations by Staff Officers  Assisting Procurement",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Declarations/Annexure II -Chapter 01 -Declarations by Staff Officers  Assisting Procurement.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure III - Chapter 01 - Non - collusion Affidavit",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Declarations/Annexure III -Chapter 01 -Non-collusion Affidavit.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Formats of Procurement PLans",
        subList: [
          {
            title: "Annexure I - Chapter 04 - Master Procurement Plan",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure I - Chapter 04 - Master Procurement Plan.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II -  Chapter 04 - Annual Proposed Procurement Plan",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure II-  Chapter 04 -Annual Proposed Procurement Plan.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure III -  Chapter 04 - Detailed Annual Procurement Plan (for General Procurements)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure III-  Chapter 04 -Detailed Annual Procurement Plan (for General Procurements).doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure IV - Chapter 04 - Detailed Annual Procurement Plan (Foreign Funded Projects)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure IV - Chapter 04 -Detailed Annual Procurement Plan (Foreign Funded Projects).doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure V - Chapter 04 - Detailed Annual Procurement Plan (for Complex Works Projects)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure V - Chapter 04 -Detailed Annual Procurement Plan (for Complex Works Projects).doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VI -  Chapter 04 - Preparatory Plan (General)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure VI -  Chapter 04 -Preparatory Plan (General).doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VII - Chapter 04 - Preparatory Plan – (for Complex Works Projects)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Procurement PLans/Annexure VII -  Chapter 04 -Preparatory Plan – (for Complex Works Projects).doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Formats of Securities",
        subList: [
          {
            title: "Annexure IX - Chapter 05 - Performance Guarantee Security",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Securities/Annexure IX- Chapter 05 -Performance Guarantee Security.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure V - Chapter 05 - Bid Security Guarantee",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Securities/Annexure V- Chapter 05 -Bid Security Guarantee.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VI - Chapter 05 - Bid Security Declaration",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Securities/Annexure VI- Chapter 05 -Bid Security Declaration.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VII - Chapter 05 - Advance Payment Guarantee",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Securities/Annexure VII- Chapter 05 -Advance Payment Guarantee.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VIII Chapter 05 - Guarantee of Release of Retention Money",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Formats of Securities/Annexure VIII Chapter 05 -Guarantee of Release of Retention Money.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Letter of Acceptance",
        subList: [
          {
            title: "Annexure I - Chapter 08 - Sample Format for Letter of Acceptance for Supply Contract",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Letter of Acceptance/Annexure I - Chapter 08-Sample Format for Letter of Acceptance for Supply Contract.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II - Chapter 08 - Sample Format for Letter of Acceptance",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Letter of Acceptance/Annexure II - Chapter 08 - Sample Format for Letter of Acceptance.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Other Matters",
        subList: [
          {
            title: "Acceptance Committee",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Acceptance Committee.docx",
            type: 'link'//link   list
          },
          {
            title: "Annexure I - Chapter 09 - Variation to Contract",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Annexure I - Chapter 09 - Variation to Contract.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure I - Chapter 05 - Specimen of Checklist Which Could Be Used for Submission of Draft Procurement Documents",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Annexure I- Chapter 05 -Specimen of Checklist Which Could Be Used for Submission of Draft Procurement Documents.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure II - Chapter 05 - Standard Procurement Documents",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Annexure II- Chapter 05 -Standard Procurement Documents.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure III - Chapter 05 - Invitation for Bids Request for BidsProposals",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Annexure III- Chapter 05 - Invitation for Bids Request for BidsProposals.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure IV - Chapter 05 - Documents Required for Each Procurement Method",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Annexure IV- Chapter 05 -Documents Required for Each Procurement Method.doc",
            type: 'link'//link   list
          },
          {
            title: "Authority Limits for Contract Awarding (Procurement Guide Line 2.9)",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Authority Limits for Contract Awarding (Procurement Guide Line 2.9).docx",
            type: 'link'//link   list
          },
          {
            title: "Major Deviations",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Major Deviations.doc",
            type: 'link'//link   list
          },
          {
            title: "Minor Deviations and Debatable Deviations",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Minor Deviations and Debatable Deviations.doc",
            type: 'link'//link   list
          },
          {
            title: "Publication of Specific Procurement Notice  Request for Bids  Request for Proposals and Fee for Issuing Procurement Documents",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Other Matters/Publication of Specific Procurement Notice  Request for Bids  Request for Proposals and Fee for Issuing Procurement Documents.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Payments to the Commiittees",
        subList: [
          {
            title: "Annexure IX - Chapter 02 Payments for Members of Bid Evaluation Committee",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Payments to the Commiittees/Annexure IX - Chapter 02 Payments for Members of Bid Evaluation Committee.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure X - Chapter 02 Payment for Staff Officers and Other Officers Assisting Procurement",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Payments to the Commiittees/Annexure X - Chapter 02 Payment for Staff Officers and Other Officers Assisting Procurement.doc",
            type: 'link'//link   list
          },
          {
            title: "AnnexureVIII - Chapter 02 Payments for Members of Procurement Committees",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Payments to the Commiittees/AnnexureVIII- Chapter 02 Payments for Members of Procurement Committees.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Procurement Committee",
        subList: [
          {
            title: "Annexure I - Chapter 02 - Minutes of Procurement Committee",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Procurement Committee/Annexure I - Chapter 02 - Minutes of Procurement Committee.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
      {
        title: "Time Frame for Procurement Process",
        subList: [
          {
            title: "Annexure IX - Chapter 04 - Time Frame for Completion of Procurement Activities in the Bidding Process without Pre-qualification",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Time Frame for Procurement Process/Annexure IX-  Chapter 04-Time Frame for Completion of Procurement Activities in the Bidding Process without Pre-qualification.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure VIII - Chapter 04 - Time Frame for Completion of Procurement Activities in the Bidding Process with Pre-qualification",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Time Frame for Procurement Process/Annexure VIII -  Chapter 04 - Time Frame for Completion of Procurement Activities in the Bidding Process with Pre-qualification.doc",
            type: 'link'//link   list
          },
          {
            title: "Annexure X -  Chapter 04 - Average Time Frame for Procurement Process",
            url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Time Frame for Procurement Process/Annexure X -  Chapter 04 - Average Time Frame for Procurement Process.doc",
            type: 'link'//link   list
          }
        ],
        type: 'list'//list   download
      },
    ],
    type: 'list'//list   download
  },
  {
    title: "Nomination Form – University Provident Fund",
    //description: "A clean and modern resume template for professionals.",
    url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/UPF-Nomination-Form.pdf",
    type: 'download'//list   download
  },
  {
    title: "Information for Recruitment of Contract and Temporary Employees",
    //description: "A comprehensive proposal template for project planning.",
    url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Information-for-Recruitment-of-Contract-and-Temporary-Employees.pdf",
    type: 'download'//list   download
  },
  {
    title: "Check List - Application for the Post of Professor",
    //description: "An example business report format for corporate use.",
    url: Configurations.baseUrl+"/assets/usjnet_doc/Downloads/Document-Check-List-for-the-Professor-Application.docx",
    type: 'download'//list   download
  }
];

  const sortedItems = downloadLinks.sort((a, b) => a.title.localeCompare(b.title));

  const LinkCard = ({ href, text, cardIcon }) => {
    return (
      <Card variant="outlined" sx={{marginBottom:1}}>
        <CardActionArea 
          component="a" 
          href={href} 
          target='_blank'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start', 
            p: 2,
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              textDecoration: 'none',
            },
          }}
        >
          {/* <IconComponent style={{ color: '#8B0000', marginRight: 16 }} /> */}
          <img src={cardIcon} alt="donwnload icon" style={{width:30,marginRight:10}} />
          <Typography variant="body1">
            {text}
          </Typography>
        </CardActionArea>
      </Card>
    );
  };

  const ListCard = ({ href, text, cardIcon,dataList }) => {
    return (
      <Card variant="outlined" sx={{marginBottom:1}}>
        <CardActionArea 
          component="a" 
          onClick={()=>navigate("/download-list", { state: dataList })}
          target='_blank'
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start', 
            p: 2,
            textDecoration: 'none',
            '&:hover': {
              backgroundColor: '#f5f5f5',
              textDecoration: 'none',
            },
          }}
        >
          {/* <IconComponent style={{ color: '#8B0000', marginRight: 16 }} /> */}
          <img src={cardIcon} alt="donwnload icon" style={{width:30,marginRight:10}} />
          <Typography variant="body1">
            {text}
          </Typography>
        </CardActionArea>
      </Card>
    );
  };

 

  return (
   <>
   <NavbarComponent />
   <div class="container">
      <div>
        <Breadcrumb separator={">"}>
            <Breadcrumb.Item as={Link} onClick={()=>navigate("/home")} href="#">
            Home
            </Breadcrumb.Item>
            <Breadcrumb.Item as={Link} >
            Downloads
            </Breadcrumb.Item>
        </Breadcrumb>
    </div>
    </div>

   <Container>
        
      <Title>Downloads</Title>

      
      {sortedItems.map((link, index) => (
        <>
        {link.type == "list" && (
          <ListCard 
          dataList={link}
          text={link.title} 
          cardIcon={ListIcon}
        />
        )}
         {link.type == "download" && (
          <LinkCard 
          href={link.url}
          text={link.title} 
          cardIcon={DownloadIcon2}
        />
        )}
        </>  

    ))}


      <div style={{ padding:200 }}></div>
    </Container>
    <FooterComponent />
   </>
  )
}
